import React, { useState } from "react";
import ButtonSecondary from "../buttons/ButtonSecondary";
import { toast } from "react-toastify";
import { Hourglass } from "react-loader-spinner";
import useBillingApi from "../../hooks/api/useBillingApi";

const ModalConfirmSubscriptions = ({
  isOpenModalSubscription,
  closeModal,
  titleModal,
  textModal,
  renewalDate,
  isSubscriptionCanceled,
  setRenewalDate,
  setIsSubscriptionCanceled,
}) => {
  const [loading, setLoading] = useState(false);
  const { subscriptionAction } = useBillingApi();

  const handleCloseModal = () => {
    closeModal();
  };
  const cancelSubscription = () => {
    setLoading(true);
    subscriptionAction()
      .then((response) => {
        const { isCanceled, renewalDate } = response.data;
        if (isCanceled === false) {
          setRenewalDate(renewalDate);
        } else {
          setIsSubscriptionCanceled(true);
        }
        toast.success("Canceled successfully!", response.data);
        setLoading(false);
        closeModal();
      })
      .catch((error) => {
        toast.error("Error canceling subscription", error.data);
        setLoading(false);
      });
  };
  const handleClickDelete = () => {
    cancelSubscription();
  };
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg mx-6 max-w-[500px]">
        <h2 className="text-h6 text-dark4 mb-4 text-center">{titleModal}</h2>
        <p className="text-bodyMR text-dark4 text-center mb-2">{textModal}</p>
        <p className="text-bodyMR text-dark4 text-center mb-4">
          This action is irreversible.
        </p>
        <div className="flex justify-center mt-6 space-x-4">
          {loading ? (
            <div className="flex justify-center items-center">
              <Hourglass
                visible={true}
                height="40"
                width="40"
                animationDuration="2"
                ariaLabel="hourglass-loading"
                wrapperStyle={{}}
                wrapperClass=""
                colors={["#FF5400", "#FF5400"]}
              />
            </div>
          ) : (
            <>
              <ButtonSecondary
                text="Delete"
                customClass="bg-redDark text-white text-bodyMR px-[22px] py-[10px]"
                onClick={handleClickDelete}
              />
              <ButtonSecondary
                text="Cancel"
                customClass="bg-white text-dark4 text-bodyMR border border-dark4 px-[22px] py-[10px]"
                onClick={handleCloseModal}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmSubscriptions;
